import { render, staticRenderFns } from "./systemAnnouncement.vue?vue&type=template&id=1b77226c&scoped=true"
import script from "./systemAnnouncement.vue?vue&type=script&lang=js"
export * from "./systemAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77226c",
  null
  
)

export default component.exports